<template>
    <dynamic-form-container :scopes="scopes" :should-notify="true" @onSubmitSuccess="onSuccess"/>
</template>

<script>
   import {mapMutations} from "vuex";
   import DynamicFormContainer from "../../organisms/forms/DynamicFormContainer";
   import formAlertMixin from "../../mixins/formAlertMixin";
   import profileSectionMixin from "../../mixins/profileSectionMixin";

    export default {
        name: "ProfileDemographic",
        components: {DynamicFormContainer},
        mounted(){
            trackEvent("ProfileViewDemographic", {})
            this.getSection('demographic')
        },
        methods: {
            ...mapMutations({
                setUserGender: 'user/setUserGender'
            }),
            onSuccess(context){
                switch(context.identifier){
                    case 'demographic':
                        this.setUserGender(context.data['6']);
                }
            }
        },
        mixins: [formAlertMixin, profileSectionMixin]
    }
</script>

